import PropTypes from 'prop-types';
import { toast } from "../../../../core/helpers/message-helper";
import FormModal from "../../../../core/ui/components/FormModal";
import { Col, Row } from "reactstrap";
import InputController from "../../../../core/ui/components/InputController";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { crearOEditarRecurso } from "../../services/recursos-service";

const REQUIRED_RULE = { required: "Este campo es requerido" };

const FormRecursos = ({ modalState, onSave }) => {
    const { recurso } = modalState.data;

    const defaultValues = {
        id: recurso.id || "",
        nombre: recurso.nombre || "",
        descripcion: recurso.descripcion || "",
        img: "",
        icono: "",
    };

    const form = useForm({ defaultValues });
    useEffect(() => form.reset(defaultValues), [recurso]);

    const onCreateRecurso = async () => {
        const formData = new FormData(document.getElementById("formRecurso"));
        const resp = await crearOEditarRecurso(formData);
        if (!resp.status) return toast.error(resp.message);

        toast.success(resp.message);
        modalState.close();
        onSave();
    };

    return (
        <FormModal
            size="lg"
            form={form}
            id="formRecurso"
            onSubmit={onCreateRecurso}
            isOpen={modalState.show}
            headerTitle={modalState.title}
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <InputController
                    name="id"
                    type="hidden"
                    errors={form.formState.errors}
                    control={form.control}
                />
                <Col sm={6}>
                    <InputController
                        name="nombre"
                        label="Nombre"
                        errors={form.formState.errors}
                        control={form.control}
                        placeholder="Nombre"
                        rules={REQUIRED_RULE}
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        name="descripcion"
                        label="Descripción"
                        errors={form.formState.errors}
                        control={form.control}
                        placeholder="Descripción"
                        rules={REQUIRED_RULE}
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        id="img"
                        name="img"
                        type="file"
                        errors={form.formState.errors}
                        label="Imágen"
                        control={form.control}
                        placeholder="Imágen"
                        rules={recurso.id == null ? REQUIRED_RULE : {}}
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        id="icono"
                        name="icono"
                        type="file"
                        errors={form.formState.errors}
                        label="Ícono"
                        control={form.control}
                        placeholder="Ícono"
                        rules={recurso.id == null ? REQUIRED_RULE : {}}
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormRecursos.propTypes = {
    modalState: PropTypes.object,
    onSave: PropTypes.func
}

export default FormRecursos;
